import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String }
  static targets = ['icon']

  copy() {
    navigator.clipboard.writeText(this.urlValue).then(() => {
      this.showCopiedState()
    })
  }

  showCopiedState() {
    // Cambiar al SVG de check
    this.iconTarget.innerHTML =
      '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>'
    this.iconTarget.classList.add('text-green-500')

    setTimeout(() => {
      this.resetState()
    }, 2000)
  }

  resetState() {
    // Restaurar al SVG de copiar
    this.iconTarget.innerHTML =
      '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>'
    this.iconTarget.classList.remove('text-green-500')
  }
}
